import Controller from "csi/action/Controller";
import SpecBuilder from "csi/core/SpecBuilder";
import csi from "csi/main";
import CustomViewAttributesStore from "csi/middleware/customView/attributes/CustomViewAttributesStore";
import localeProvider from "csi/page/localeProvider";
import { getDomainClasses } from "csi/reflection/reflection";
import declare from "dojo/_base/declare";
import { each, groupBy, isEmpty } from "lodash";

const PathCheck = declare(Controller, {
	_onAction(): void {
		const duplicates = {};

		getDomainClasses().forEach(({ type }) => {
			const attributesStore = new CustomViewAttributesStore(localeProvider);
			const specBuilder = new SpecBuilder(type);
			attributesStore.addLevel({ specBuilder });

			const containers = Object.values(attributesStore.containerMap);
			const grouped = groupBy(containers, "name");
			const typeDuplicates = {};

			each(grouped, (containers, name) => {
				if (containers.length > 1) {
					typeDuplicates[name] = containers.map((container) => container.extendedPath.value);
				}
			});
			
			if (!isEmpty(typeDuplicates)) {
				duplicates[type] = typeDuplicates;
			}
		});

		const w = window.open("", "Paths");
		const doc = w.document;

		doc.write("<HTML><HEAD><TITLE>Duplicate Preference Path Names</TITLE></HEAD>");
		doc.write("<BODY><pre>");
		doc.write(csi.objectToString(duplicates, 0, "\n"));
		doc.write("</pre></BODY></HTML>");
		doc.close();
	},
});

export = PathCheck;
